import type { ConfigType } from './index';

type RegionalApiConfig = {
  readonly API: Readonly<Partial<Pick<ConfigType['API'], 'AI' | 'GRAPHQL_BFF' | 'FILES' | 'ACCOUNTS' | 'USERS'>>>;
};

// All Stage EU apps use the EU gateway for browser calls. Verify required BFF
// operations before onboarding another app. Server calls inherit cluster-local
// FILES/ACCOUNTS/USERS from staging.js. Production retains US bootstrap destinations.
// AUTH and KEYCLOAK continue to come from the base config in both environments.
export const europeConfig = {
  prod: {
    API: {
      FILES: 'https://v2-prod-api-files.prod.newfront.com',
      ACCOUNTS: 'https://v2-prod-api-account.prod.newfront.com',
      USERS: 'https://v2-prod-api-users.prod.newfront.com',
    },
  },
  stage: {
    API: {
      AI: 'https://kong.stage.eu.newfront-development.com',
      GRAPHQL_BFF: 'https://kong.stage.eu.newfront-development.com/api/bff/graphql',
    },
  },
} as const satisfies Record<'prod' | 'stage', RegionalApiConfig>;
